import {
  faArrowUpRight,
  faArrowDownLeft,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface PercentageDifferenceProps {
  currentValue: number;
  priorValue: number;
  comparisonLabel: string;
}

/**
 * Percentage change between the selected range and the period of the same
 * length immediately before it.
 *
 * @param param0 - The props containing the current and prior values.
 * @returns A JSX element displaying the percentage difference.
 */
const PercentageDifference = ({
  currentValue,
  priorValue,
  comparisonLabel,
}: PercentageDifferenceProps) => {
  const renderDifference = () => {
    const fillRatePercentageDifference =
      ((currentValue - priorValue) / (priorValue || 1)) * 100;

    if (fillRatePercentageDifference > 0) {
      return (
        <span className="flex items-center font-semibold text-green-600">
          <FontAwesomeIcon icon={faArrowUpRight} className="mr-1" />
          {fillRatePercentageDifference.toFixed(1)}%
        </span>
      );
    } else if (fillRatePercentageDifference < 0) {
      return (
        <span className="flex items-center font-semibold text-red-600">
          <FontAwesomeIcon icon={faArrowDownLeft} className="mr-1" />
          {Math.abs(fillRatePercentageDifference).toFixed(1)}%
        </span>
      );
    }
    return (
      <span className="flex items-center font-semibold text-gray-500">0%</span>
    );
  };

  return (
    <div className="flex items-center gap-1 text-xs">
      {renderDifference()}
      <span className="text-gray-500">{comparisonLabel}</span>
    </div>
  );
};

export default PercentageDifference;
